import { styled } from '@mui/material/styles';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';

type Props = {
    tree: TreeT | null;
    rowRenderer?: (node: TreeT) => JSX.Element;
    expandedValues?: string[];
    setExpanded?: (expandedValues: string[]) => void;
    defaultExpandedIds?: string[];
};

const StyTreeItem = styled(TreeItem, {
    name: 'StyTreeItem',
})(({ theme }) => ({
    '.MuiTreeItem-content': {
        borderRadius: theme.spacing(1),
        MozUserSelect: 'none',
        KhtmlUserSelect: 'none',
        WebkitUserSelect: 'none',
        MsUserSelect: 'none',
        userSelect: 'none',
    },
    '.MuiTreeItem-content.Mui-focused': {
        backgroundColor: 'inherit',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
}));

export const Tree = ({
    tree,
    rowRenderer,
    expandedValues,
    setExpanded,
    defaultExpandedIds,
}: Props): JSX.Element => {
    const renderNode = (node: TreeT) => {
        const label = rowRenderer ? rowRenderer(node) : node.label;
        return (
            <StyTreeItem key={node.value} itemId={node.value} label={label}>
                {node.children.map((n) => renderNode(n))}
            </StyTreeItem>
        );
    };

    return (
        <SimpleTreeView
            sx={{ flex: 1 }}
            disableSelection
            expandedItems={expandedValues}
            defaultExpandedItems={defaultExpandedIds}
            onExpandedItemsChange={
                setExpanded
                    ? (_: unknown, nodeIds: string[]) => setExpanded(nodeIds)
                    : undefined
            }
        >
            {tree?.children.map((node) => renderNode(node))}
        </SimpleTreeView>
    );
};
